import { Icon } from '../icons/Icon.jsx';
import { PALETTE } from '../config/palette.js';

/* 색상 선택 (팔레트 + 직접 선택) */
export function ColorPicker({ value, onChange }) {
  return (
    <div className="swatches">
      {PALETTE.map(c => (
        <button key={c} type="button" className={"swatch" + (value === c ? " is-on" : "")} style={{ background: c }} onClick={() => onChange(c)} aria-label={c}></button>
      ))}
      <label className="swatch swatch--custom" title="직접 선택">
        <Icon name="plus" size={14} />
        <input type="color" value={value || '#6b56ff'} onChange={e => onChange(e.target.value)} style={{ position: 'absolute', inset: 0, opacity: 0, cursor: 'pointer' }} />
      </label>
    </div>
  );
}

export default ColorPicker;
